<template>
  <div :id="id" :queryDate="queryDate" :queryType="queryType"></div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import * as echarts from 'echarts';

export default {
  name: "oeeDeviceCount",
  mixins: [EmCommonApi],
  props: {
    id: String,
    queryDate: String,
    queryType: Number,
  },
  data() {
    return {
      chart: {},
      dataValueX: [],
      dataValueY: [],
      queryRotorStatorGroup: [],
      codeAndNameRelation: [],
      option: {},
      fresh: {},
      barMinWidth: 60,
      barMaxWidth: 60,
      receiveDate: '',
      barColor: '#FFCC00',
      seriesData: [],
    }
  },
  watch: {
    //监听queryDate的变化，这个queryDate是父组件传递的参数，利用watch监听再刷新当前子组件
    // queryDate(newValue, oldValue) {
    //     console.log("旧日期：" + oldValue + "父组件传递的新日期：" + newValue)
    //     this.getRemoteData();
    // }
  },
  created() {

    this.fetchData();
  },
  mounted() {
    //window.addEventListener('resize', this.chart.resize, false);

    //定时轮巡查询
    this.fresh = setInterval(() => {
      //子组件自己初始化查询日期
      if (this.queryDate === "") {
        this.receiveDate = this.formatDateTime(new Date());

      } else {
        this.receiveDate = this.queryDate;
      }

      this.fetchData();
      window.addEventListener('resize', this.chart.resize, false)
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.fresh);
    //window.removeEventListener('resize', this.chart.resize, false)
  },
  methods: {
    fetchData() {
      //1、取Rotor&Stator组的设备编码，用于判断变色
      const _api = `${this.$_emApiMixin_moduleBaseApi("tpmOeeReportTor")}/tpmOeeReportTor/getDeviceCodesFromSysParam?type=2`
      this.$_emApiMixin_get(_api, false).then(value => {
        let data = value;
        this.queryRotorStatorGroup = data;

        //2、取设备编码和设备名称对应关系 getDeviceCodeAndNameRelationFromSysParam
        const _api = `${this.$_emApiMixin_moduleBaseApi("tpmOeeReportTor")}/tpmOeeReportTor/getDeviceCodeAndNameRelationFromSysParam`
        this.$_emApiMixin_get(_api, false).then(value => {
          let data = value;
          this.codeAndNameRelation = data;

          //3、取统计OEE
          this.getRemoteData();
        })
      })
    },
    getRemoteData() {

      const _api = `${this.$_emApiMixin_moduleBaseApi("tpmOeeReportTor")}/tpmOeeReportTor/getOeeDeviceCount?date=`
          + this.receiveDate + "&type=" + this.queryType
      console.log(_api)

      //注意给后端传递年份查询参数 {s_year: this.year}
      this.$_emApiMixin_get(_api, false).then(value => {
        let data = value;
        //console.log('--------------- DeviceCount 后端返回结果 ----------------')
        //console.log(data)

        //取对应属性的对象
        this.dataValueX = Object.keys(data);
        this.dataValueY = Object.values(data);
        //console.log(this.dataValueX)
        //console.log(this.dataValueY)
        this.formatSeriesData(this.dataValueY);
        //渲染echart
        this.loadChart()
      })
    },
    formatSeriesData(originalData) {
      //重组Y轴数组，控制每一个value的position
      // 初始化空数组
      this.seriesData = [];

      // 遍历后端数据数组，构建 ECharts 数据对象
      for (let i = 0; i < originalData.length; i++) {
        const value = originalData[i];
        const labelPosition = value > 7 ? 'insideRight' : 'right';
        // 构建数据对象，包括值和标签设置
        const dataItem = {
          value: value,
          label: {
            show: true,
            position: labelPosition
          }
        };
        // 将数据对象添加到数据数组中
        this.seriesData.push(dataItem);
      }
    },
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
      const day = String(date.getDate()).padStart(2, '0');

      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    loadChart() {
      // 获取屏幕缩放比例动态计算
      let scale = window.devicePixelRatio || 1;
      // 设定原始字体大小（在100%缩放下的字体大小）
      let originalSize = 20; // 适合100%缩放的字体大小
      // 根据缩放比例调整字体大小
      let adjustedSize = originalSize * (1 / scale);

      let _self = this;
      this.option = {
        title: {
          //数组样式（会有灰色逗号间隔）
          // text: [
          //     '{styleA|Rotor & Stator}', // 使用富文本标签 'a' 来定义样式1
          //     '  ', // 添加一个空格作为间隔
          //     '{styleB|Casing}', // 使用富文本标签 'b' 来定义样式2
          // ],
          text: '{styleA|转子 & 定子}        {styleC|缸体}\n{styleB|Rotor & Stator}    {styleD|Casing}',
          left: 'center',
          top: 'top',
          textStyle: {
            rich: {
              // 定义富文本样式 'styleA'
              styleA: {
                fontSize: adjustedSize, // 设置字体大小
                fontWeight: 'bold', // 设置字体加粗
                color: '#CC66FF' // 设置字体颜色
              },
              // 定义富文本样式 'styleB'
              styleB: {
                fontSize: adjustedSize, // 设置字体大小
                fontWeight: 'bold', // 设置字体加粗
                color: '#CC66FF' // 设置字体颜色
              },
              // 定义富文本样式 'styleC'
              styleC: {
                fontSize: adjustedSize, // 设置字体大小
                fontWeight: 'bold', // 设置字体加粗
                color: '#0099FF' // 设置字体颜色
              },
              // 定义富文本样式 'styleD'
              styleD: {
                fontSize: adjustedSize, // 设置字体大小
                fontWeight: 'bold', // 设置字体加粗
                color: '#0099FF' // 设置字体颜色
              }
            }
          }
        },
        color: [this.barColor], // (全局)设置bar的颜色
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            // params 包含了 tooltip 的各种信息
            var tooltipContent = '<div style="width: 150px; text-align: left;">';
            tooltipContent += '<strong>'
                + params[0].name
                + '&nbsp;&nbsp;'
                + _self.codeAndNameRelation[params[0].name]
                + '</strong><br/>';

            // 在此处添加在tooltip中显示的其他内容
            // 通过 params[i] 访问数据点的属性
            // 例如，params[0], params[1]等根据数据索引而定
            for (var i = 0; i < params.length; i++) {
              tooltipContent += '<div style="margin-right: 10px; display: inline-block;">';
              // 使用 CSS 设置小圆点的颜色
              tooltipContent += '<span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background-color: ' + params[i].color + ';"></span>';
              tooltipContent += '</div>';
              tooltipContent += params[i].seriesName + ': ' + params[i].value + '%<br/>';
            }
            tooltipContent += '</div>';
            return tooltipContent;
          }
        },
        // legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          splitLine: {
            show: true,             // 显示分隔线
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'  // 设置分隔线的颜色和透明度
            }
          },
          axisLabel: {
            textStyle: {
              color: '#ffffff',   // 设置 x 轴刻度标签的字体颜色
              fontSize: adjustedSize - 2,       // 设置 x 轴刻度标签的字体大小
            }
          },
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          splitLine: {
            show: false,             // 显示分隔线
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'  // 设置分隔线的颜色和透明度
            }
          },
          axisLabel: {
            textStyle: {
              color: '#ffffff',   // 设置 x 轴刻度标签的字体颜色
              fontSize: adjustedSize - 2,       // 设置 x 轴刻度标签的字体大小
            }
          },
          axisLine: {
            lineStyle: {
              color: '#00CC00'  // 设置 y 轴轴线颜色
            }
          },
          // data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10',
          //     '11', '12', '13', '14', '15', '17', '18', '19', '20',
          //     '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'] //test data
          inverse: true, // 将 y 轴刻度颠倒显示
          data: this.dataValueX
        },
        series: [
          {
            name: 'Parts',
            type: 'bar',
            barWidth: adjustedSize + 10,         // 设置柱子的宽度
            label: {
              show: true,             // 显示标签
              color: 'rgba(255, 255, 255, 0.9)', // 标签文字颜色
              fontSize: adjustedSize - 3, // 标签文字大小
              //fontWeight: 'bold',
              //position: 'insideRight',     // 标签位置：inside表示在柱子内部
              formatter: '{c}%'        // 标签内容格式化
              // formatter: function (params) {
              //     // 根据数据值 params.value 决定是否显示标签
              //     if (params.value < 5) {
              //         return '';
              //     } else {
              //         return params.value + '%'; // 否则显示数据值
              //     }
              // },
            },
            // data: [44, 55, 34, 19, 22, 11, 35.5, 46, 14, 22, 16.8]   //test data
            data: this.seriesData, //已对this.dataValueY重新格式化，赋值position
            itemStyle: {
              // 使用函数来匹配为分组设备的bar设置不同的颜色
              color: function (params) {
                //var RotorStatorGroup = ['S1-19', 'S3-27', 'S3-28', 'S1-20',
                //    'S5-12', 'S3-20', 'S3-22', 'S1-21', 'S3-6'];   //test
                var rotorStatorGroup = _self.queryRotorStatorGroup.slice();     //注意_self
                // 检查当前柱子的数据在 arrA 中是否存在
                if (rotorStatorGroup.indexOf(params.name) !== -1) {
                  // 如果存在，设置一种颜色
                  return '#CC66FF'; // 设置颜色1
                } else {
                  // 如果不存在，设置另一种颜色
                  return '#0099FF'; // 设置颜色2
                }
              }
            }
          },
        ]
      }
      this.chart = echarts.init(document.getElementById(this.id));
      this.chart.setOption(this.option)

      //echart浏览器自动缩放
      let myChart = this.chart;
      window.addEventListener('resize', () => {
        myChart.resize();
      })
    }
  }
}
</script>

<style scoped>

</style>
